module.exports = __webpack_public_path__ + "static/img/document-before-print-au-tfn.c1e4d128.png";